import { LabelValue } from "../../../helpers/types/common";

export const BulkEditProgramSelectionFormKey = {
  selectedType: "selectedType",
  downloadTemplate: "downloadTemplate",
  uploadTemplate: "uploadTemplate",
};

export const BulkEditSearchParticipantFormKey = {
  clientName: "clientName",
  clientId: "clientId",
  deliveryCountry: "deliveryCountry",
  productLine: "productLine",
  programTemplate: "programTemplate",
  participantStatus: "participantStatus",
} as const;

export interface BulkEditSearchParticipantFormType {
  clientId: string;
  clientName: string;
  deliveryCountry: string[];
  productLine: string[];
  programTemplate: string;
  participantStatus: string;
}

export const searchParticipantsDefaultValues = {
  [BulkEditSearchParticipantFormKey.clientId]: "",
  [BulkEditSearchParticipantFormKey.clientName]: "",
  [BulkEditSearchParticipantFormKey.deliveryCountry]: [],
  [BulkEditSearchParticipantFormKey.productLine]: [],
  [BulkEditSearchParticipantFormKey.programTemplate]: "",
  [BulkEditSearchParticipantFormKey.participantStatus]: "",
};

export const defaultFilter = "FilterBy.EqualTo";

export const SearchParticipantsResultFormKey = {
  isSelected: "isSelected",
  participantName: "participantName",
  clientName: "clientName",
  participantKeyNumber: "participantKeyNumber",
  deliveryCountryName: "deliveryCountryName",
  lobName: "lobName",
  programTemplateName: "programTemplateName",
  status: "status",
  participantEmailAddress: "participantEmailAddress",
  createdDate: "createdDate",
} as const;

export interface UniqueParticipantResultFiltersTypes {
  deliveryCountry: LabelValue[];
  lobName: LabelValue[];
  programTemplate: LabelValue[];
  status: LabelValue[];
}

export enum ModalType {
  ClientValidation = 0,
  MinimumParticipantsRequired = 1,
}

export interface ModalState {
  type: ModalType | null;
  show: boolean;
}
export interface HeaderCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}
export const bulkEditBaseFileName = "Bulk_Edit_Program_";
